'use client';

import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Box, Flex, Stack } from '@mantine/core';
import { useStore } from '@/stores';
import { IconButton } from '@/ui';
import { SearchButton } from '../Search';
import { AgencyButton } from './AgencyButton';
import { NavbarButton } from './NavbarButton';
import classes from './Navbar.module.css';

export const InternalNavbar = observer(() => {
  const { t } = useTranslation();
  const store = useStore();

  return (
    <>
      <Box
        className={classes.navbar}
        w={store.navbar.collapsed ? 0 : store.navbar.width}
        data-collapsed={store.navbar.collapsed ? true : undefined}
      >
        <Box className={classes.navbar__content} miw={store.navbar.width - 16}>
          <Stack gap="xs">
            <Flex
              justify="space-between"
              align="center"
              direction="row"
              className={classes.navbar__header}
              gap="xs"
            >
              <AgencyButton />
              <SearchButton visibleFrom="sm" />
              <IconButton
                iconName="chevronsLeft"
                variant="subtle"
                onClick={() => store.navbar.toggle()}
                hiddenFrom="sm"
              />
            </Flex>
            <Stack gap={0}>
              <NavbarButton label={t('navbar.trello')} icon="brandTrello" href="/admin/trello" />
              <NavbarButton label={t('navbar.users')} icon="users" href="/admin/users" />
              <NavbarButton label={t('navbar.platforms')} icon="social" href="/admin/platforms" />
              <NavbarButton label={t('navbar.apiTokens')} icon="key" href="/admin/api-tokens" />
              <NavbarButton
                label={t('navbar.featureFlags')}
                icon="adjustments"
                href="/admin/feature-flags"
              />
            </Stack>
          </Stack>
        </Box>
      </Box>
      {!store.navbar.collapsed && (
        <Box className={classes.navbar__overlay} onClick={() => store.navbar.toggle()} />
      )}
    </>
  );
});
